import style from "css/hotdesking.module.css";
import React, { useCallback, useLayoutEffect, useState } from "react";
import { DatePicker, Select, TimePicker } from "antd";
import {
  DownOutlined,
  EnvironmentOutlined,
  UpOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

function Search({
  date,
  setDate,
  time,
  setTime,
  location,
  setLocation,
  bookCnt,
  resourceCnt,
  locationList,
  departmentList,
  departmentId,
  isFind,
  setIsFind,
}) {
  const { t } = useTranslation();
  return (
    <section className={style.content_search}>
      <section className={style.search_options}>
        <div className={style.option_item}>
          <p className={style.item_title}>
            {t("HOTDESKING.SEARCH.TITLE.LOCATION")}
          </p>
          <Location
            setLocation={setLocation}
            locationList={locationList}
            departmentList={departmentList}
            departmentId={departmentId}
            isFind={isFind}
            setIsFind={setIsFind}
          />
        </div>
        <div className={style.option_item}>
          <p className={style.item_title}>
            {t("HOTDESKING.SEARCH.TITLE.DATE")}
          </p>
          <div className={style.item_content}>
            <DatePicker
              className={style.picker}
              value={dayjs(date, "YYYY-MM-DD")}
              minDate={dayjs(
                dayjs(new Date()).format("YYYY-MM-DD"),
                "YYYY-MM-DD"
              )}
              onChange={(value) => setDate(dayjs(value).format("YYYY-MM-DD"))}
              allowClear={false}
            />
            <TimePicker.RangePicker
              className={style.picker}
              format={"HH:mm"}
              onChange={(dates) =>
                setTime({
                  start: dayjs(dates[0]).format("HH:mm"),
                  end: dayjs(dates[1]).format("HH:mm"),
                })
              }
              suffixIcon={<></>}
              placeholder={["시작시간", "종료시간"]}
              value={[dayjs(time.start, "HH:mm"), dayjs(time.end, "HH:mm")]}
              allowClear={false}
              changeOnScroll
              inputReadOnly
            />
          </div>
        </div>
      </section>

      <section className={style.resource_display}>
        {location != null && (
          <>
            <DisplayItem
              cnt={resourceCnt - bookCnt}
              title={t("HOTDESKING.SEARCH.TITLE.AVAILABLE_SEATS")}
            />
            <DisplayItem
              cnt={bookCnt}
              title={t("HOTDESKING.SEARCH.TITLE.RESERVED_SEATS")}
            />
          </>
        )}
      </section>
    </section>
  );
}

export default Search;

function DisplayItem({ cnt, title }) {
  return (
    <div className={style.display_item}>
      <p className={style.item_content}>{cnt}</p>
      <p className={style.item_title}>{title}</p>
    </div>
  );
}
function Location({
  setLocation,
  locationList,
  departmentList,
  departmentId,
  isFind,
  setIsFind,
}) {
  const [parent, setParent] = useState(null);
  const [child, setChild] = useState(null);
  const [children, setChildren] = useState([]);

  const onSelectParent = useCallback(
    (selectKey) => {
      const childrenList = departmentList.filter(
        (item) => item.parentId === selectKey
      );

      if (childrenList.length < 1) {
        const location = locationList.filter(
          (item) => item.departmentId === selectKey
        );
        setLocation(location[0]);
        setChildren([]);
        // setChild(null);
      } else {
        setChildren(childrenList);
      }
      setChild(null);
      setParent(departmentList.filter((item) => item.value === selectKey)[0]);
    },
    [departmentList, locationList, setLocation]
  );

  const onSelectChild = useCallback(
    (selectKey) => {
      const location = locationList.filter(
        (item) => item.departmentId === selectKey
      );
      setLocation(location[0]);
      setChild(departmentList.filter((item) => item.value === selectKey)[0]);
    },
    [departmentList, locationList, setLocation]
  );

  const onFindDepartment = useCallback(() => {
    const department = departmentList.filter(
      (item) => item.value === departmentId
    )[0];

    if (
      department !== undefined &&
      department.parentId !== undefined &&
      department.parentId !== ""
    ) {
      onSelectParent(department.parentId);
      onSelectChild(department.value);
    } else {
      const location = locationList.filter(
        (item) => item.departmentId === department.value
      );
      setLocation(location[0]);
      setChildren([]);
      setChild(null);
      setParent(
        departmentList.filter((item) => item.value === department.value)[0]
      );
    }
  }, [
    departmentId,
    departmentList,
    locationList,
    onSelectChild,
    onSelectParent,
    setLocation,
  ]);

  useLayoutEffect(() => {
    if (
      isFind &&
      departmentId !== null &&
      locationList.length > 0 &&
      departmentList.length > 0
    ) {
      onFindDepartment();
      setIsFind(false);
    }
  }, [
    departmentId,
    departmentList.length,
    isFind,
    locationList.length,
    onFindDepartment,
    setIsFind,
  ]);

  return (
    <section className={style.item_content_section}>
      <SelectItem
        list={departmentList.filter((item) => item.parentId === "")}
        value={parent}
        onSelect={onSelectParent}
      />
      {children.length > 0 && (
        <SelectItem list={children} value={child} onSelect={onSelectChild} />
      )}
    </section>
  );
}
function SelectItem({ list, value, onSelect }) {
  const [open, setOpen] = useState(false);
  const onDropdownVisibleChange = (open) => {
    setOpen(open);
  };
  return (
    <Select
      className={style.item_content}
      prefix={<EnvironmentOutlined />}
      suffix={open ? <DownOutlined /> : <UpOutlined />}
      onDropdownVisibleChange={onDropdownVisibleChange}
      onSelect={onSelect}
      options={list}
      value={value}
    />
  );
}
